import { render, staticRenderFns } from "./preventionTrainingPagination.vue?vue&type=template&id=99f429ac&"
import script from "./preventionTrainingPagination.vue?vue&type=script&lang=js&"
export * from "./preventionTrainingPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports